import { Injectable } from '@angular/core';
import { BaseComponent } from '@wms/app/components';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BuildPreferencesService extends BaseComponent {
  private sharedDataSubject = new BehaviorSubject<any>({});
  appConfigData: any = this.sharedDataSubject.asObservable();
  splashImgSrc = '';
  showErrorMessage: boolean;
  message: { type: string; caption: string; };

  updateAppConfigData(newData: Object): void {
    this.sharedDataSubject.next(newData);
  }

  showErrMsg(msg: string, type = 'error') {
    this.showErrorMessage = true;
    this.message = {
      type,
      caption: msg
    };
  }
}
